import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {
  Button,
  Col,
  Divider,
  Form,
  Icon,
  Input,
  message,
  Row,
  Select,
  Switch,
  Upload,
} from 'antd';
import {
  Categories,
  McCkEditor,
  SubCategories,
  Tags,
  Video,
} from '../../../components';
import {post} from '../../../components/mc_axios/McAxios';
import {
  arrayConcat,
  getLocalData,
  getSubjectList,
  getSystemList,
  setLocalData,
  slugify,
} from '../../../components/util';
import '../Medvideo.css';
import {connect} from 'react-redux';
import {getUserRoleReselector} from '../../../redux/selectors';

const {TextArea} = Input;
const Dragger = Upload.Dragger;
const Option = Select.Option;

class EditMedvideoForm extends React.Component {
  handlers = {};
  state = {
    title: '',
    isPrime: false,
    subjectsList: [],
    subjects: [],
    systemsList: [],
    systems: [],
    tags: [],
    category: undefined,
    subCategory: undefined,
    description: '',
    videoUrl: '',
    videoDuration: 0,
    videoThumbnail: '',
    reference: '',
    mNotesUrl: '',
    metaTitle: '',
    slug: '',
    metaDescription: '',
    metaKeywords: [],
  };

  componentDidMount() {
    getSubjectList(subjects => {
      this.setState({
        subjectsList: subjects,
      });
    });

    getSystemList(systems => {
      this.setState({
        systemsList: systems,
      });
    });
    // this.getMedvideoDetails();
  }

  getVideoDuration = (videoUrl) => {
    if (videoUrl !== '') {
      let video = document.createElement('video');
      video.setAttribute('src', videoUrl);
      document.body.appendChild(video);
      video.onloadeddata = (event) => {
        const duration = event.target.duration;
        const parsedDuration = Math.trunc(duration);
        setLocalData('create-medvideo-videoUrl', videoUrl, 1);
        setLocalData('create-medvideo-videoDuration', parsedDuration, 1);
        this.setState({
          videoUrl,
          videoDuration: Math.trunc(parsedDuration),
        }, () => document.body.removeChild(video));
      };
    }
  };

  getMedvideoDetails = () => {
    const title = getLocalData('create-medvideo-title', 1);

    let isPrime = getLocalData('create-medvideo-isPrime', 1);
    isPrime = isPrime !== '' && isPrime === 'true';

    this.setState({
      title,
      isPrime,
      subjects: getLocalData('create-medvideo-subjects', 2),
      systems: getLocalData('create-medvideo-systems', 2),
      tags: getLocalData('create-medvideo-tags', 2),
      description: getLocalData('create-medvideo-description', 1),
      videoUrl: getLocalData('create-medvideo-videoUrl', 1),
      videoDuration: getLocalData('create-medvideo-videoDuration', 3),
      videoThumbnail: getLocalData('create-medvideo-videoThumbnail', 1),
      reference: getLocalData('create-medvideo-reference', 1),
      mNotesUrl: getLocalData('create-medvideo-mNotesUrl', 1),
      metaTitle: title,
      slug: slugify(title),
      metaDescription: getLocalData('create-medvideo-metaDescription', 1),
      metaKeywords: getLocalData('create-medvideo-metaKeywords', 2),
    });
  };

  // New methods
  handleChangeByEvent = name => {
    if (!this.handlers[name]) {
      this.handlers[name] = event => {
        const {value} = event.target;
        setLocalData('create-medvideo-' + name, value, 1);
        this.setState({
          [name]: value,
        });
      };
    }
    return this.handlers[name];
  };

  handleChangeByValue = name => {
    if (!this.handlers[name]) {
      this.handlers[name] = value => {
        setLocalData('create-medvideo-' + name, value, 2);
        this.setState({
          [name]: value,
        });
      };
    }
    return this.handlers[name];
  };

  //title
  handleFillMetaTitleSlug = e => {
    const {value} = e.target;
    this.setState({
      metaTitle: value,
      slug: slugify(value),
    });
  };

  //Tags methods
  handleMetaKeywordsFill = value => {
    const keywords = value.map(d => d.key);
    const newArr = arrayConcat(keywords, this.state.metaKeywords);
    setLocalData('create-medvideo-metaKeywords', newArr, 2);
    this.setState({
      metaKeywords: newArr,
    });
  };

  //Category methods
  handleCategoryCreate = value => {
    const data = {
      key: value.key,
      label: value.label,
    };
    this.setState({
      category: data,
      subCategory: undefined,
    });
  };

  handleCategoryChange = name => {
    if (!this.handlers[name]) {
      this.handlers[name] = value => {
        this.setState({
          category: value,
          subCategory: undefined,
        });
      };
    }
    return this.handlers[name];
  };

  //Sub Category methods
  handleCreateSubCategory = value => {
    const data = {
      key: value.key,
      label: value.label,
    };
    this.setState({
      subCategory: data,
    });
  };

  handleSubCategoryChange = value => {
    this.setState({
      subCategory: value,
    });
  };

  //Editor methods
  handleEditorChange = name => {
    if (!this.handlers[name]) {
      this.handlers[name] = event => {
        const data = event.editor.getData();
        setLocalData('create-medvideo-' + name, data, 1);
        this.setState({
          [name]: data,
        });
      };
    }
    return this.handlers[name];
  };

  //Video methods
  handleVideoChange = info => {
    if (info.file.status === 'done') {
      this.getVideoDuration(info.file.response.data.file_url);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  handleRemoveVideo = () => {
    this.setState({
      videoUrl: '',
      videoDuration: 0,
    });
  };

  handleVideoThumbnailChange = info => {
    if (info.file.status === 'done') {
      const {file_url} = info.file.response.data;
      setLocalData('create-medvideo-videoThumbnail', file_url, 1);
      this.setState({
        videoThumbnail: file_url,
      });
      message.success('Thumbnail uploaded successfully');
    } else if (info.file.status === 'error') {
      message.error('Thumbnail upload failed');
    }
  };

  handleVideoThumbnailRemove = () => {
    this.setState({
      videoThumbnail: '',
    });
  };

  //Update & Publish methods
  create = () => {
    this.handleSubmit(1);
  };

  createAndPublish = () => {
    this.handleSubmit(2);
  };

  handleSubmit = saveType => {
    const {
      title,
      isPrime,
      subjects,
      systems,
      tags,
      category,
      subCategory,
      description,
      videoUrl,
      videoDuration,
      videoThumbnail,
      reference,
      mNotesUrl,
      metaTitle,
      slug,
      metaDescription,
      metaKeywords,
    } = this.state;

    if (title === '' || videoUrl === '') {
      message.error('Title and video is mandatory');
    } else {
      let tagsList = [];
      if (tags !== undefined) {
        for (let j = 0; j < tags.length; j++) {
          tagsList.push(tags[j].key);
        }
      }

      let data = {
        title,
        status: saveType,
        prime: isPrime,
        subject: subjects,
        system: systems,
        tags: tagsList,
        category_id: category !== undefined && category.hasOwnProperty('key') ?
            category.key :
            '',
        sub_category_id: subCategory !== undefined &&
        subCategory.hasOwnProperty('key') ? subCategory.key : '',
        description,
        video_url: videoUrl,
        video_alt_text: title,
        duration: videoDuration,
        video_thumbnail: videoThumbnail,
        reference,
        m_notes_url: mNotesUrl,
        meta_title: metaTitle,
        slug,
        meta_description: metaDescription,
        meta_keywords: metaKeywords,
      };

      post('/api/television/videos/create', data).then(response => {
        if (response.data.status === true && response.data.code === 200) {
          message.success('medVideo has been created');
          this.props.history.push('/dashboard/medvideo/');
        } else message.error('Something went wrong. Please try again.');
      });
    }
  };

  resetFieldsData = () => {
    setLocalData('create-medvideo-title', '', 1);
    setLocalData('create-medvideo-isPrime', false, 1);
    setLocalData('create-medvideo-subjects', 0, 1);
    setLocalData('create-medvideo-systems', 0, 1);
    setLocalData('create-medvideo-tags', 0, 1);
    setLocalData('create-medvideo-featured-image-url', 0, 1);
    setLocalData('create-medvideo-featured-image-alt-text', 0, 1);
    setLocalData('create-medvideo-meta-description', '', 1);
    setLocalData('create-medvideo-mNotesUrl', '', 1);
    setLocalData('create-medvideo-meta-title', '', 1);
    setLocalData('create-medvideo-meta-slug', '', 1);
    setLocalData('create-medvideo-meta-keywords', [], 2);
  };

  render() {
    const {userRole} = this.props;
    const {title, description, subjectsList, subjects, systemsList, systems, tags, videoUrl, videoThumbnail, isPrime, category, subCategory, reference, mNotesUrl, metaTitle, slug, metaDescription, metaKeywords} = this.state;

    const isRestricted = userRole !== 2;

    return (
        <Form>
          <Row className="main-content-block" gutter={16}>
            <Col span={12}>
              <div className="page-header">
                <Link to={'/dashboard/medvideo/'}>
                  <Icon type="arrow-left" title={'Back'}/>
                </Link>
                <Divider type="vertical"/> Create MedVideo
              </div>
            </Col>
            <Col span={12} className="text-right">
              <Button
                  htmlType="button"
                  onClick={this.create}
                  className="mc-mr-5"
              >
                Save
              </Button>
              <Button
                  type={'primary'}
                  htmlType="button"
                  onClick={this.createAndPublish}
              >
                Save & Publish
              </Button>
            </Col>
            <Col span={24}>
              <hr className="mc-mt-10"/>
            </Col>
            <Col xs={24} lg={15}>
              <Row gutter={16}>
                <Col span={24}>
                  <p className={'mc-mt-10'}>
                    Title:
                    {
                      !isRestricted && (
                          <span className="pull-right">
                            Premium
                            <Switch
                                className="mc-ml-15"
                                checked={isPrime}
                                checkedChildren="Yes"
                                unCheckedChildren="No"
                                onChange={this.handleChangeByValue('isPrime')}
                                style={{width: 60}}
                            />
                         </span>
                      )
                    }
                  </p>
                </Col>
                <Col span={24}>
                  <Form.Item>
                    <Input
                        placeholder="Enter medVideo title"
                        size={'large'}
                        value={title}
                        onChange={this.handleChangeByEvent('title')}
                        onBlur={this.handleFillMetaTitleSlug}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item label="Subject">
                    <Select
                        mode="multiple"
                        placeholder="Select subject"
                        size={'large'}
                        value={subjects}
                        onChange={this.handleChangeByValue('subjects')}
                    >
                      {subjectsList.map(function(subject, index) {
                        return (
                            <Option value={subject} key={index}>
                              {subject}
                            </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item label="System">
                    <Select
                        mode="multiple"
                        placeholder="Select system"
                        size={'large'}
                        value={systems}
                        onChange={this.handleChangeByValue('systems')}
                    >
                      {systemsList.map(function(system, index) {
                        return (
                            <Option value={system} key={index}>
                              {system}
                            </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Tags
                      value={tags}
                      onChange={this.handleChangeByValue('tags')}
                      onBlur={this.handleMetaKeywordsFill}
                  />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <Categories
                      value={category}
                      onChange={this.handleCategoryChange('category')}
                      onCreateCategory={this.handleCategoryCreate}
                  />
                </Col>
                <Col xs={24} sm={12}>
                  <SubCategories
                      value={subCategory}
                      categoryValue={category}
                      onChange={this.handleSubCategoryChange}
                      onCreateSubCategory={this.handleCreateSubCategory}
                  />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label="Description">
                    <McCkEditor
                        content={description}
                        onMcEditorChange={this.handleEditorChange(
                            'description')}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  {videoUrl === '' ? (
                      <Form.Item label="Video">
                        <Dragger
                            name="file"
                            accept=".mp4, .mvk, .wmv"
                            action="/api/media/upload"
                            data={{
                              product_type: 3,
                            }}
                            multiple={false}
                            onChange={this.handleVideoChange}
                        >
                          <p className="ant-upload-drag-icon">
                            <Icon type="inbox"/>
                          </p>
                          <p className="ant-upload-text">
                            Click or drag file to this area to upload
                          </p>
                          <p className="ant-upload-hint">
                            Support for a single or bulk upload. Strictly
                            prohibit
                            from uploading company data or other band files
                          </p>
                        </Dragger>
                      </Form.Item>
                  ) : (
                      <Row>
                        <Col span={24}>
                          <p>Video :</p>
                        </Col>
                        <Col span={24}>
                          <Video
                              videoSrc={videoUrl}
                              videoTitle="MedVideo"
                          />
                        </Col>
                        <Col span={24}>
                          <Button
                              className="mc-mt-10"
                              type="primary"
                              htmlType="button"
                              onClick={this.handleRemoveVideo}
                          >
                            Remove
                          </Button>
                        </Col>
                      </Row>
                  )}
                </Col>
                <Col span={24}>
                  {videoThumbnail === '' ? (
                      <Form.Item label="Video Thumbnail">
                        <Dragger
                            name="file"
                            accept=".jpg, .jpeg, .png"
                            action="/api/media/upload"
                            data={{
                              product_type: 3,
                            }}
                            multiple={false}
                            onChange={this.handleVideoThumbnailChange}
                        >
                          <p className="ant-upload-drag-icon">
                            <Icon type="inbox"/>
                          </p>
                          <p className="ant-upload-text">
                            Click or drag file to this area to upload
                          </p>
                        </Dragger>
                      </Form.Item>
                  ) : (
                      <Row>
                        <Col span={24}>
                          <p className="mc-mt-20">Video Thumbnail :</p>
                        </Col>
                        <Col span={24}>
                          <img
                              src={videoThumbnail}
                              style={{width: '100%', maxWidth: 400}}
                              alt="Thumbnail"
                          />
                        </Col>
                        <Col span={24}>
                          <Button
                              className="mc-mt-10"
                              type="primary"
                              htmlType="button"
                              onClick={this.handleVideoThumbnailRemove}
                          >
                            Remove
                          </Button>
                        </Col>
                      </Row>
                  )}
                </Col>
              </Row>
            </Col>
            <Col xs={24} lg={9}>
              <Row>
                <Col span={24}>
                  <Form.Item label="Reference">
                    <McCkEditor
                        type={1}
                        content={reference}
                        onMcEditorChange={this.handleEditorChange(
                            'reference')}
                    />
                  </Form.Item>
                </Col>
                {
                  !isRestricted && (
                      <Col span={24}>
                        <Form.Item label={'mNote'}>
                          <Input
                              placeholder="Enter mNote url"
                              size={'large'}
                              value={mNotesUrl}
                              onChange={this.handleChangeByEvent('mNotesUrl')}
                          />
                        </Form.Item>
                      </Col>
                  )
                }
              </Row>
              <div className="seo-section">
                <Row gutter={16}>
                  <Col span={24}>
                    <h3>SEO</h3>
                    <hr/>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Meta Title">
                      <Input
                          placeholder="Enter meta title"
                          size={'large'}
                          value={metaTitle}
                          onChange={this.handleChangeByEvent('metaTitle')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Slug">
                      <Input
                          size={'large'}
                          value={slug}
                          onChange={this.handleChangeByEvent('slug')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Meta Description">
                      <TextArea
                          rows={4}
                          value={metaDescription}
                          onChange={this.handleChangeByEvent(
                              'metaDescription')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Meta Keywords">
                      <Select
                          mode="tags"
                          placeholder="Enter keywords"
                          size={'large'}
                          value={metaKeywords}
                          onChange={this.handleChangeByValue('metaKeywords')}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Form>
    );
  }
}

const mapStateToProps = state => {
  return {
    userRole: getUserRoleReselector(state),
  };
};

const CreateMedvideo = withRouter(
    connect(mapStateToProps, null)(EditMedvideoForm));

export {CreateMedvideo};
